import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@env/environment';

/**
 * ApiService
 */
@Injectable({ providedIn: 'root' })
export class ApiService {
  /**
   * options
   * @type {{headers: {'Content-Type': string}}}
   */
  private options = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  /**
   * constructor
   * @param {HttpClient} http
   */
  constructor(private http: HttpClient) {}

  /**
   * formatErrors
   * @param {HttpErrorResponse} err
   * @returns {Observable<never>}
   */
  private formatErrors(err: HttpErrorResponse): Observable<never> {
    return throwError(err);
  }

  /**
   * get
   * @param {string} path
   * @param {HttpParams} params
   * @returns {Observable<any>}
   */
  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${environment.apiUrl}${path}`, { params }).pipe(catchError(this.formatErrors));
  }

  /**
   * put
   * @param {string} path
   * @param {object} body
   * @param {object} options
   * @returns {Observable<any>}
   */
  put(path: string, body: object = {}, options: object = {}): Observable<any> {
    return this.http
      .put(`${environment.apiUrl}${path}`, JSON.stringify(body), {
        ...this.options,
        ...options,
      })
      .pipe(catchError(this.formatErrors));
  }

  /**
   * post
   * @param {string} path
   * @param {object} body
   * @param {object} options
   * @returns {Observable<any>}
   */
  post(path: string, body: object = {}, options: object = {}): Observable<any> {
    return this.http
      .post(`${environment.apiUrl}${path}`, JSON.stringify(body), {
        ...this.options,
        ...options,
      })
      .pipe(catchError(this.formatErrors));
  }

  /**
   * delete
   * @param {string} path
   * @returns {Observable<any>}
   */
  delete(path: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}${path}`).pipe(catchError(this.formatErrors));
  }

  postFile(path: string, body: object = {}, options: object = {}): Observable<any> {
    return this.http.post(`${environment.apiUrl}${path}`, body).pipe(catchError(this.formatErrors));
  }
}
